// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26zFn","label":"styles_label__1kPRx"};